import Container from "../../components/container/container";
import ContainerTitle from "../../components/container-title/container-title";
import AppointmentCard from "./appointment-card/appointment-card";
import { Appointments, DashboardStyled, StyledTabs } from "./dashboard.styles";
import { Appointment } from "./types";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo, useState } from "react";
import { getAllAppointments } from "../../actions";
import { AxiosError } from "axios";
import { useAppDispatch } from "../../store/hooks";
import { addNotification } from "../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { EventNote } from "@mui/icons-material";
import Loader from "../../components/loader/loader";
import { formatDataUsingChicagoTime } from "../../utils/common-utils";
import ReusableTabs from "../../components/tabs/tabs";
import { GlobalContext } from "../../context/GlobalProvider";
import { Box } from "@mui/material";

const AppointmentTabContent = ({ loading, appointments }: any) => {
  return (
    <Box>
      {loading ? (
        <Loader absolute />
      ) : (
        <Appointments>
          {appointments && appointments.length > 0 ? (
            appointments.map((d: any, index: number) => (
              <AppointmentCard
                key={index}
                data={formatDataUsingChicagoTime(d)}
              />
            ))
          ) : (
            <div className="no-data">
              <EventNote style={{ fontSize: 50 }} />
              <p>No appointments booked</p>
            </div>
          )}
        </Appointments>
      )}
    </Box>
  );
};

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [appointments, setAppointments] = useState<Appointment[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { providersAppointmentData } = useContext(GlobalContext);

  const [activeTab, setActiveTab] = useState<string | null>(null);
  const handleAction = () => navigate("/dashboard/book-appointments");
  const provider =
    providersAppointmentData?.find((x: any) => x?.display_name === activeTab)
      ?.actor_id || "";

  useEffect(() => {
    setLoading(true);

    if (provider) {
      getAllAppointments(provider)
        .then((response) => {
          const { data } = response.data;
          setAppointments(data);
        })
        .catch((error: AxiosError) => {
          dispatch(
            addNotification({
              id: uuid(),
              type: "error",
              message: error.message,
            })
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [activeTab, dispatch, provider, providersAppointmentData]);

  useEffect(() => {
    setActiveTab(providersAppointmentData?.[0]?.display_name);
  }, [providersAppointmentData]);

  const tabs = useMemo(() => {
    if (!providersAppointmentData) return [];
    return providersAppointmentData.map((x: any) => {
      let content = null;
      if (x?.display_name === "Tech Appointments") {
        content = (
          <AppointmentTabContent
            loading={loading}
            appointments={appointments}
          />
        );
      } else {
        content = (
          <AppointmentTabContent
            loading={loading}
            appointments={appointments}
          />
        );
      }
      return {
        label: x?.display_name,
        content: content,
      };
    });
  }, [appointments, loading, providersAppointmentData]);

  return (
    <Container>
      <DashboardStyled>
        <ContainerTitle
          title="Upcoming appointments"
          showButton={true}
          buttonLabel="Book appointment"
          buttonAction={handleAction}
        />
        <Appointments>
          {providersAppointmentData?.length === 0 ? (
            <Loader absolute />
          ) : (
            <StyledTabs className="main-wrapper">
              <ReusableTabs
                tabs={tabs}
                onTabChange={(newValue) => {
                  setAppointments(null);
                  setActiveTab(newValue);
                }}
              />
            </StyledTabs>
          )}
        </Appointments>
      </DashboardStyled>
    </Container>
  );
};

export default Dashboard;
